import _crud from './_crud'
import { callApi } from '../../utils/api'
import { showSuccessMessage } from '../../utils/messages'
const entity = 'reservation'
const messageEntity = 'la reservación'
const messagePluralEntity = 'las reservaciónes'
const actions = _crud(entity, messageEntity, messagePluralEntity)

export const cancelReservationClientPortal = (reservationId) => {
	return async (dispatch, getState) => {
		const state = getState();

		try {
			const res = await callApi(`/reservation/cancel_reservation/client_portal/${reservationId}`, {
				method: "GET",
				headers: {
					Authorization: state.app?.client?.token,
				}
			})
			if(res?.status == 200){
				return res.body?.data;
			}
		}catch(error){
			throw error;
		}
	}
}

export const loadReservationsClientPortal = (options = {}) => {
	return async (dispatch, getState) => {
	   const state = getState();
	   //  Check if the entities have been loaded before
	   try{
		  if (
			 Object.keys((state[`${entity}s`]?.entities ?? state[entity]?.entities)).length <= 2 ||
			 options.force === true
		  ) {
			 dispatch({
				type: `FETCH_${entity.toUpperCase()}S`,
			 });

			 const res = await callApi(`/${entity}/load_reservation/client_portal`, {
				method: 'GET',
				headers: {
				   Authorization: state.app?.client?.token,
				},
				params: options.params,
			 });

			 
			 dispatch({
				type: `LOAD_${entity.toUpperCase()}S_AND_REMAINS`,
				response: res.body,
			 });
 
			 return res.body;
		  }
	   }catch(e){
		  dispatch({
			 type: `UNLOAD_${entity.toUpperCase()}S`,
		  });
	   }
	};
};

export const getReservationSchedulesClientPortal = (sysCompanyId, reservationDateTime) => {
	return async (dispatch, getState) => {
		const state = getState();

		try {
			const companyId = sysCompanyId ? sysCompanyId : state.access?.foodStallId ? state.access?.foodStallId : state.access?.sysCompanyId
			if(!companyId){
				return
			}
			const res = await callApi(`/reservation/get_schedules_for_reservations/client_portal/${companyId}/${reservationDateTime}`, {
				method: "GET",
				headers: {
					Authorization: state.app?.client?.token,
				}
			});
			if(res?.status == 200){
				return res.body?.data;
			}
			return res.body
		} catch(error){
			throw error;
		}
	}
};

export const createReservationClientPortal = (data={}) => {
	return async (dispatch, getState) => {
		const state = getState()
		
		try{
			const body = {sys_company_id: state.access.sysCompanyId, ...data}
			const res = await callApi('/reservation/create_reservation/client_portal', {
				method: 'POST',
				headers: {
					Authorization: state.app?.client?.token,
				},
				body: JSON.stringify(body),
				successMessage: `Su solicitud ha sido enviada correctamente.`,
			})

			if(res.status == 200){
				// dispatch({
				// 	type: 'ADD_RESERVATION',
				// 	response: res.body
				// })

				dispatch({type: 'ADD_UPCOMING_RESERVATIONS'})
			}
	
			return res.body
		}catch(e){
			return
		}
	}
}

export default actions
